<template>
  <div class="container page fund-manage">
    <van-nav-bar title="資金管理" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="list-card">
      <div class="list-row" @click="toBankCard">
        <span>金融卡</span>
        <van-icon name="arrow" />
      </div>
      <div class="list-row" @click="toUsdtAddress">
        <span>USDT地址</span>
        <van-icon name="arrow" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    back() {
      return window.history.back();
    },
    toBankCard() {
      this.$router.push({ path: '/Setbank' });
    },
    toUsdtAddress() {
      this.$router.push({ path: '/UsdtAddress' });
    },
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' });
    }
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/base.css";

/* 與資金管理參考圖：左紫 → 右粉；列表大字粗體 */
@grad-purple: #4f2b8a;
@grad-pink: #f560cd;

.fund-manage {
  background: #f3f3f5;
  min-height: 100%;
}

.nav-bar {
  position: relative;
}

.nav-bar::v-deep .van-nav-bar {
  background: linear-gradient(90deg, @grad-purple, @grad-pink);
}

.nav-bar::v-deep .van-nav-bar::after {
  display: none;
}

.nav-bar::v-deep .van-nav-bar__title {
  max-width: 70%;
  color: #fff;
  font-size: 38px;
  font-weight: 700;
}

.nav-bar::v-deep .van-icon {
  font-size: 40px;
}

.list-card {
  margin-top: 0;
  background: #fff;
}

.list-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 22px 20px;
  min-height: 96px;
  box-sizing: border-box;
  color: #111;
  font-size: 34px;
  font-weight: 700;
  border-bottom: 1px solid #e8e8e8;
}

.list-row:last-child {
  border-bottom: none;
}

.list-row .van-icon {
  flex-shrink: 0;
  margin-left: 12px;
  color: #c0c0c0;
  font-size: 36px;
}
</style>
